export function safeLabReturn(value: string | null, origin: string): string {
  if (!value || !value.startsWith('/') || value.startsWith('//')) return '/lab/pelican-test'
  try {
    const url = new URL(value, origin)
    if (url.origin !== origin || (url.pathname !== '/lab' && !url.pathname.startsWith('/lab/'))) return '/lab/pelican-test'
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return '/lab/pelican-test'
  }
}

/** Same-origin bridge that checks a possibly existing session before OAuth. */
export function loginBridgeUrl(returnPath: string): string {
  const query = new URLSearchParams({ redirect: returnPath })
  return `/lab/auth/continue?${query}`
}

/**
 * Production OAuth callbacks are canonical on www.sandbase.ai. Starting OAuth
 * from the apex host would create a host-only state cookie on sandbase.ai that
 * cannot accompany the provider callback to www, producing a false "expired"
 * page. Canonicalise only the production apex; localhost stays local.
 */
export function canonicalLoginUrl(returnPath: string, currentOrigin: string): string {
  const origin = new URL(currentOrigin)
  if (origin.protocol === 'https:' && origin.hostname === 'sandbase.ai') origin.hostname = 'www.sandbase.ai'
  const login = new URL('/login', origin.origin)
  login.searchParams.set('redirect', returnPath)
  return login.toString()
}
